import React, { useEffect, useState } from 'react';
import { IPageData } from '../../../../interfaces/page';
import { useFetchPageData, usePageData } from '../../../../hooks/usePage';
import {
  Card,
  Col,
  Form,
  InputNumber,
  Row,
  Switch,
  Button,
  Input, DatePicker, Spin, message, TimePicker, Result
} from 'antd';
import locale from 'antd/es/date-picker/locale/es_ES';
import eleccionesProvider from '../../../../services/eleccionesProvider';
import { IEleccion, IEleccionModel } from '../../../../interfaces/elecciones/eleccion';
import { IResponse } from '../../../../interfaces/response';
import EleccionVigente from './component/eleccionvigente';
import { navigateHome } from '../../../../utils/naviagate-home';

const { RangePicker } = DatePicker;
const pageData: IPageData = {
  fulFilled: false,
  breadcrumbs: [
    {
      title: 'Inicio',
      route: 'default-dashboard'
    },
    {
      title: 'Comité SST',
      route: 'eleccion-admin'
    },
    {
      title: 'Elección'
    }
  ]
};
const formItemLayout = {
  labelCol: {
    span: 7
  },
  wrapperCol: {
    span: 14
  }
};

const EleccionAdmin = () => {
  usePageData(pageData);
  const [data] = useFetchPageData<IEleccion>('/elecciones/ObtenerEleccionVIgente', null);
  useEffect(() => {
    console.log('', data);
  }, [data]);

  const [form] = Form.useForm();
  const [guardandoeleccion, setguardandoeleccion] = useState(false);

  const guardarEleccion = async (e: IEleccionModel) => {
    setguardandoeleccion(true);
    e.periodoIni = e.Periodo[0];
    e.periodoFin = e.Periodo[1];
    const res: any = await eleccionesProvider.guardarEleccion(e);
    //TODO VALIDAR
    setguardandoeleccion(false);
    form.resetFields();
    if (res.succeeded) {
      message.success(res.message);
    } else {
      message.warning(res.message, 10);
      return;
    }
    navigateHome();
  };

  return (
    <>
      <Row>
        <Col span={16}>
          <Spin spinning={guardandoeleccion}>
            <Card title={'Configuración de elecciones'}>
              <Form form={form} {...formItemLayout} onFinish={guardarEleccion}
                    initialValues={{
                      'MaxPostulantes': 10,
                      'Activo': true
                    }}
              >
                <Form.Item name={'Nombre'} label={'Nombre de la Elección'} rules={[{
                  required: true,
                  message: 'Ingrese un nombre para la elección'
                }]}>
                  <Input />
                </Form.Item>
                <Form.Item name={'Descripcion'} label='Descripción'>
                  <Input.TextArea />
                </Form.Item>
                <Form.Item name='Periodo' label='Periodo de Elección' rules={[{
                  required: true,
                  type: 'array',
                  message: 'Ingrese un periodo valido'
                }]}>
                  <RangePicker format={['DD/MM/YYYY']} locale={locale} placeholder={['Desde', 'Hasta']} />
                </Form.Item>
                <Form.Item name={'HoraFin'} label={'Hora Fin'}
                           rules={[{ required: true, message: 'Es necesario establecer una hora fin de la elección' }]}>
                  <TimePicker use12Hours format='h:mm a' placeholder={'HH:MM'} />
                </Form.Item>
                <Form.Item label='Maximo'>
                  <Form.Item name='MaxPostulantes' noStyle>
                    <InputNumber min={1} max={50} />
                  </Form.Item>
                  <span className='ant-form-text'> Postulantes</span>
                </Form.Item>
                <Form.Item name='Activo' label='Activo' valuePropName='checked'>
                  <Switch />
                </Form.Item>
                <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
                  <Button disabled={data != null && data.eleccion != null} type='primary' htmlType='submit'>
                    Registrar
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Spin>
        </Col>
        <Col span={8}>
          {data != null && data.eleccion != null ? <EleccionVigente eleccion={data} /> :
            <Result
              status='info'
              title='GESSOMA'
              subTitle='Actualmente no existe una Elección configurada.'
            />
          }
        </Col>
      </Row>
    </>
  );
};

export default EleccionAdmin;
